(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let io;
  const observe = (root = document) => {
    const els = root.querySelectorAll('.pz-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    io = io || new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach((el) => io.observe(el));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => observe());
  else observe();
  document.addEventListener('shopify:section:load', (e) => observe(e.target));
})();
